import $ from "jquery";
import axios from "axios";
import authHeader from "./auth-header";
import AdminService from "./admin.service";
import ClientService from "./client.service";
import jQuery from "jquery";

const BASE_URL = AdminService.getBaseUrl();
const API_URL = BASE_URL + "/api/v1/admin";
const DEFAULT_ERROR_MESSAGE = 'We are trying to complete your request. Please try again.';

class ErrorService {
  getDefaultErrorMessage(){
    return DEFAULT_ERROR_MESSAGE;
  }
  async logException(location, err, type) {
    if (sessionStorage.getItem("logout-in-progress") === "true") {
      return;
    }
    const params = new URLSearchParams();
    params.append("error_message", err);
    params.append("location", location);
    params.append("error_type", type);
    params.append("client_id", ClientService.getClientId());
    await axios
      .post(API_URL + "/process-error", params, { headers: await authHeader() })
      .then(response => console.log(JSON.stringify(response))) // eslint-disable-line no-console
      .catch(error => console.log(JSON.stringify(error))); // eslint-disable-line no-console
  }
  async processException(location, err, type, panelApp) {
    let logger = panelApp.$log;
    logger.error("Error: " + err);

    this.logException(location, err, type);

    var error_message = "Type: " + type + " Error Message: " + err;
    error_message += "     Location: " + location;
    error_message += "     Axios Info: " + this.axiosErrorMessage(err);
    // https://meyerweb.com/eric/tools/dencoder/
    panelApp.$gtag.exception({
      description: error_message,
      fatal: false
    });
    let userErrorMessage = DEFAULT_ERROR_MESSAGE;
    let isAccessDenied = error_message.includes("Access is denied");
    if (isAccessDenied == true){
      userErrorMessage = "Your session has expired. Please logout and login again to continue";
    }
    AdminService.displayErrorMessage({ text: userErrorMessage }, 5000);

    if (typeof panelApp.$root.setLoading != "undefined") {
      panelApp.$root.setLoading(false);
    }
  }
  mergeError(response) {
    let errorMessage = "";
    if (typeof response != "undefined" && typeof response.data != "undefined" && typeof response.data.message != "undefined") {
      errorMessage += " : ";
      errorMessage += response.data.message;
    } 
    return errorMessage;
  }
  axiosErrorMessage(error) {
    let axiosErrorMessage = " ";
    if (typeof error != "undefined" && typeof error.config != "undefined" && typeof error.config.url != "undefined") {
      axiosErrorMessage += "     URL: " + error.config.url;
      if (typeof error.config.data != "undefined") {
        axiosErrorMessage += "     Data: " + error.config.data;
        axiosErrorMessage += "     FullJSON: " + JSON.stringify(error.toJSON());
      }
    } else {
      axiosErrorMessage = " Axios data not available";
    }
    return axiosErrorMessage;
  }

  async processError(location, response, type, panelApp) {
    if (sessionStorage.getItem("logout-in-progress") === "true") {
      return;
    }
    if (typeof panelApp.$root.setLoading != "undefined") {
      panelApp.$root.setLoading(false);
    }
    let logger = panelApp.$log;
    logger.error("Response: " + JSON.stringify(response));
    var error_message;
    if (response.message === "") {
      error_message = "Error Connecting to the Server ";
    } else {
      error_message = response.message;
    }
    if (error_message === null) {
      error_message = response.debugMessage;
    }
    if (type == "chart") {
      error_message = "Chart could not be generated because of the following error: " + error_message;
    }
    error_message = "Type: " + type + "     Error Message:  " + error_message;
    let userErrorMessage = DEFAULT_ERROR_MESSAGE;
    let isAccessDenied = error_message.includes("Access is denied");
    if (isAccessDenied == true){
      userErrorMessage = "Your session has expired. Please logout and login again to continue";
    }
    AdminService.displayErrorMessage({ text:  userErrorMessage },5000);

    error_message += " Location: " + location;
    error_message += " Axios Info: " + this.axiosErrorMessage(response);
    panelApp.$gtag.exception({
      description: error_message,
      fatal: false
    });
    const params = new URLSearchParams();
    params.append("error_message", response);
    params.append("location", location);
    params.append("error_type", type);
    params.append("client_id", ClientService.getClientId());
    await axios
      .post(API_URL + "/process-error", params, { headers: await authHeader() })
      .then(response => logger.error(JSON.stringify(response)))
      .catch(error => logger.error(JSON.stringify(error)));
  }
  setupValidationForm(i18n) {
    jQuery.validator.setDefaults({
      debug: true,
      ignore: [],
      success: "valid",
    });
    jQuery.extend(jQuery.validator.messages, {
      required: i18n.t("requiredError")
    });
    jQuery.validator.addMethod(
      "notEqual",
      function(value, element, param) {
        return this.optional(element) || value != param;
      },
      i18n.t("chooseValueError")
    );
    jQuery.validator.addMethod(
      "phoneUS",
      function(phone_number, element) {
        phone_number = phone_number.replace(/\s+/g, "");
        return this.optional(element) || (phone_number.length > 9 && phone_number.match(/^(\+?1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/));
      },
      i18n.t("phoneNumberError")
    );
    jQuery.validator.addMethod(
      "emailDomainVerification",
      function(value, element) {
        let validEmailDomains = (element.getAttribute("data-email-domain-verification-list") || "")
          .split(";")
          .map(domain => domain.trim().replace(/^@/, "").toLowerCase())
          .filter(domain => domain != "");
        if (validEmailDomains.length == 0) {
          return true;
        }
        if (value.trim() == "") {
          return false;
        }
        let emailDomain = value.toLowerCase().split("@").pop();
        return validEmailDomains.includes(emailDomain);
      },
      function(params, element) {
        return element.getAttribute("data-msg-email-domain-verification");
      }
    );
    jQuery.validator.addMethod(
      "radioNoLabelsRequired",
      function(value, element) {
        return (
          $(element)
            .parent()
            .parent()
            .find(":checked").length > 0 &&
          $(element)
            .parent()
            .parent()
            .find(":checked")
            .val() != "0"
        );
      },
      i18n.t("requiredError")
    );
    jQuery.validator.addMethod(
      "typeAheadValueMatchesItemsList",
      function(value, element) {
        if (element.value == "true") {
          return true;
        } else {
          return false;
        }
      },
      i18n.t("chooseValueError")
    );
    jQuery.validator.addMethod(
      "dragInitialized",
      function(value, element) {
        if (element.value == "true") {
          return true;
        } else {
          return false;
        }
      },
      i18n.t("dragError")
    );
    jQuery.validator.addMethod(
      "selectNone",
      function(value, element) {
        if (element.value == "0" || element.value == "-1" || element.value == "") {
          return false;
        } else return true;
      },
      i18n.t("selectOptionError")
    );
    jQuery.validator.addMethod(
      "notSure",
      function(value, element) {
        return (
          $(element)
            .parent()
            .parent()
            .find(":checked").length > 0 &&
          $(element)
            .parent()
            .parent()
            .find(":checked")
            .val() != "0"
        );
      },
      i18n.t("selectOptionError")
    );
    return {
      rules: {},
      highlight: function(element) {
        $(element)
          .closest(".form-group")
          .removeClass("has-success")
          .addClass("has-error");
      },
      unhighlight: function(element) {
        $(element)
          .closest(".form-group")
          .removeClass("has-error")
          .addClass("has-success");
      },
      errorElement: "medium",
      errorClass: "form-text text-danger",
      errorPlacement: function(error, element) {
        if (element.length) {
          if (element.is(":radio") || element.is(":checkbox")) {
            error.appendTo(element.parents(".question-radio-label"));
          } else {
            var targetParent = $(element).parent();
            if (targetParent.hasClass("form-check") || targetParent.hasClass("custom-control")) {
              targetParent = targetParent.parent();
            }
            targetParent.append(error);
          }
        }
      }
    };
  }
}

export default new ErrorService();
